<template>
  <div
    class="yx-predicted-page main-layout predicted-item-page"
    v-loading="handleLoading"
  >
    <el-card shadow="never" class="box-form box-inner box-bg">
      <c-title slot="header" title="报到行程"></c-title>
      <div class="pb90">
        <div class="div-scroll">
          <el-row class="add-form">
            <el-form
              size="small"
              :model="handleData"
              ref="cForm"
              :rules="formRules"
              label-width="180px"
              :disabled="disabled"
            >
              <el-col :span="24">
                <c-form-item :formItems="formItems" ref="cFormItem" />
              </el-col>
              <el-col :span="12" v-if="handleData.trafficType == '火车'">
                <c-form-item :formItems="formItems2" ref="cFormItem" />
              </el-col>
              <el-col :span="12">
                <c-form-item :formItems="formItems3" ref="cFormItem" />
              </el-col>
              <!-- <el-col :span="24">
                <div class="tips-container" style="padding: 0">
                  <div class="img-upload" style="padding: 0">
                    <div
                      class="title"
                      style="line-height: 40px; padding-left: 150px"
                    >
                      <span class="red">*</span
                      >请上传本人及随行人员3天内健康码和行程码(需暴露身份证号)，去过中高风险地区的人员需上传14天内核酸检测报告。
                    </div>
                    <div
                      class="evidence-upload upload-item"
                      style="margin-left: 150px"
                    >
                      <el-upload
                        action=""
                        list-type="picture-card"
                        accept="image/jpeg,image/jpg,image/png,image/bmp,image/gif"
                        :file-list="fileList"
                        :headers="{ token }"
                        :on-success="handlePictureSuccess"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handlePictureRemove"
                        :on-error="handleError"
                        :http-request="customUpload"
                      >
                        <i class="el-icon-plus" slot="default"></i>
                      </el-upload>
                    </div>
                  </div>
                </div>
              </el-col> -->
              <el-col :span="24" class="accompany">
                <div class="label">随行亲友</div>
                <div class="accompany-table">
                  <el-card shadow="never">
                    <div class="btn-left">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="goto('', '')"
                        >新增</el-button
                      >
                    </div>
                    <c-table :data="accompanyList" :tableColumns="tableColumns">
                      <template slot="custom" slot-scope="scope">
                        <el-button
                          type="danger"
                          class="leave-btn"
                          @click="handleDelete(scope.$index)"
                          >删除</el-button
                        >
                      </template>
                    </c-table>
                  </el-card>
                  <div class="remark">
<!--                    注意：随行人员能否入校依据校园防控要求决定。-->
                  </div>
                </div>
              </el-col>
              <el-col :span="24" style="text-align: center; padding-top: 20px">
                <el-form-item label-width="0">
                  <slot name="other">
                    <el-button
                      type="primary"
                      @click="updateInfo"
                      size="medium"
                      :disabled="isSubmit || disabled"
                      >提交</el-button
                    >
                  </slot>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
      </div>
    </el-card>
    <!-- 添加信息弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      width="40%"
    >
      <el-form
        label-position="right"
        label-width="120px"
        :model="accompanyForm"
        :rules="accompanyFormRules"
        ref="accompanyForm"
      >
        <el-form-item label="随从亲友关系" prop="relationship">
          <el-select v-model="accompanyForm.relationship" placeholder="请选择">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in options"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="亲友姓名" prop="name">
          <el-input v-model="accompanyForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactPhone">
          <el-input v-model="accompanyForm.contactPhone"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetFields">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { validatePhoneCorrect } from "@/libs/elementChecker";
import Configs from "./data/ybd.js";
import MHandle from "@/mixins/MHandle.js";
import { guid } from "@/libs/tools.js";
import mUpload from "@/mixins/MUpload.js";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPath: "",
  handleGetPathNoparam: "/welcome-forecast/transport/myInfo",
  handleInsertPath: "/welcome-forecast/transport/save",
  handleUpdatePath: "/welcome-forecast/transport/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mHandle, mUpload],
  provide() {
    return {
      cForm: this,
    };
  },
  props: {
    id: String,
  },
  data() {
    let { formItems, formItems2, formItems3, formRules, tableColumns } =
      Configs(this);
    return {
      formItems,
      formItems2,
      formItems3,
      formRules,
      tableColumns,
      value: {},
      token: "",
      accompanyForm: {
        relationship: "",
        name: "",
        contactPhone: "",
      },
      accompanyFormRules: {
        relationship: [
          {
            required: true,
            trigger: "blur",
            message: "请选择随从亲友关系",
          },
        ],
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入亲友姓名",
          },
        ],
        contactPhone: [
          {
            trigger: "blur",
            validator: validatePhoneCorrect,
          },
        ],
      },
      options: [
        { label: "父亲", value: "父亲" },
        { label: "母亲", value: "母亲" },
        { label: "哥哥", value: "哥哥" },
        { label: "弟弟", value: "弟弟" },
        { label: "姐姐", value: "姐姐" },
        { label: "妹妹", value: "妹妹" },
        { label: "祖父母", value: "祖父母" },
        { label: "外祖父母", value: "外祖父母" },
        { label: "其他亲属", value: "其他亲属" },
      ],
      dialogFormVisible: false,
      accompanyList: [],
      title: "",
      index: "",
      studentId: "",
      forecastLinkId: "",
      isSubmit: false,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      pictureUrl: [],
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  watch: {
    handleData: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.token = localStorage.getItem("token");
    this.studentId = JSON.parse(localStorage.getItem("userInfo")).studentId;
    this.forecastLinkId = this.$route.params.id;
  },
  mounted() {
    // this.getWelcomSite(); // 查询乘车点列表
    this.getTransportInfo(); //查询个人交通信息
  },
  methods: {
    // 获取乘车点选项列表
    getWelcomSite() {
      this.$http
        .get("/welcome-forecast/welcome-car/listPage")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.formItems2[0].options = res.data.records.map((item) => {
              return {
                label: item.location,
                value: item.id,
              };
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleBeforeFn(data) {
      data.forecastLinkId = this.forecastLinkId;
      data.studentId = this.studentId;
      console.log(data);
    },
    updateInfo() {
      // 若不需要迎新车辆，则清空车辆相关信息
      // if (this.handleData.trafficType != "校迎新车辆") {
      //   this.handleData.welcomeStation = "";
      //   this.handleData.arriveStationTime = "";
      //   this.handleData.trainInfo = "";
      // }
      // if (this.pictureUrl.length) {
      // 获取图片信息
      // let pictureUrl = this.pictureUrl.length
      //   ? this.pictureUrl.map((item) => item.url)
      //   : [];
      // this.handleData.pictureUrl = pictureUrl;
      // console.log(this.handleData);
      this.$refs.cForm.validate((valid) => {
        if (valid) {
          this.$confirm("请确认无误后提交，是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.isSubmit = true;
              if (this.handleData.id) {
                this.handleUpdate();
              } else {
                this.handleInsert();
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
      // } else {
      //   return this.$message.error(
      //     "请按要求上传健康码、行程码以及核酸报告等材料！"
      //   );
      // }
    },
    // 获取学生到校信息
    getTransportInfo() {
      this.handleLoading = true;
      this.$http
        .get("/welcome-forecast/transport/myInfo")
        .then((res) => {
          // console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            let data = res.data || {};
            data.arriveSchoolTime = data.arriveSchoolTime
              ? data.arriveSchoolTime
              : "2024-09-11";
            data.timeType = data.timeType ? data.timeType : 1;
            data.trafficType = data.trafficType ? data.trafficType : "其他";
            this.handleData = data;
            // console.log(this.handleData);
            this.accompanyList = res.data.entourageList || [];
            // 回显图片
            // if (res.data.pictureUrl && res.data.pictureUrl.length) {
            //   res.data.pictureUrl.forEach((item) =>
            //     this.fileList.push({ url: item, name: item })
            //   );
            //   this.pictureUrl = [...this.fileList];
            // }
          } else {
            this.$message.error(`${res.msg}`);
          }
          this.handleLoading = false;
        })
        .catch((err) => {
          this.handleLoading = false;
        });
    },
    handleDialogClose() {
      this.dialogFormVisible = false;
      this.$refs.accompanyForm.resetFields();
    },
    goto(data, index) {
      this.resetAccompanyForm();
      this.dialogFormVisible = true;
      this.index = index;
      if (data) {
        this.title = "编辑";
        this.accompanyForm = Object.assign({}, data);
      } else {
        this.title = "新增";
      }
    },
    resetFields() {
      this.dialogFormVisible = false;
      this.resetAccompanyForm();
    },
    submit() {
      this.$refs["accompanyForm"].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          if (this.index !== "") {
            this.accompanyList[this.index] = Object.assign(
              {},
              this.accompanyForm
            );
          } else {
            this.accompanyList.push(Object.assign({}, this.accompanyForm));
          }
        }
      });
    },
    resetAccompanyForm() {
      this.accompanyForm = {
        relationship: "",
        name: "",
        contactPhone: "",
      };
    },
    handleDelete(index) {
      this.accompanyList.splice(index, 1);
    },
    handleAfterFn() {
      this.isSubmit = false;
      // this.$router.go(0);
      this.$router.replace("/welcome/student/predicted");
    },
    handlePictureSuccess(res, file, fileList) {
      console.log(res);
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.fileList = fileList;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleFormRemove(file, fileList) {
      this.formFileList = fileList;
    },
    handlePictureRemove(file, fileList) {
      this.fileList = fileList;
      let index = this.pictureUrl.findIndex((item) => item.name == file.name);
      this.pictureUrl.splice(index, 1);
    },
    handleError(err) {
      this.$message.error("上传失败，" + err);
    },
    // 自定义上传方法
    customUpload(e) {
      console.log(e);
      let self = this;
      var file = e.file;
      var fileName = guid();
      self.obsUpload(file, fileName, this.afterObsUpload);
    },
    afterObsUpload(obsUrl, file) {
      this.pictureUrl.push({ url: obsUrl, name: file.name });
    },
  },
};
</script>

